module.exports = __webpack_public_path__ + "img/xingm.a221ad68.png";